import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './public/login/login.component';
import { SecureComponent } from './secure/secure.component';
import { RegisterComponent } from './public/register/register.component';
import { PublicComponent } from './public/public.component';
import { UsersComponent } from './secure/users/users.component';
import { DashboardComponent } from './secure/dashboard/dashboard.component';
import { ProfileComponent } from './secure/profile/profile.component';
import { RolesComponent } from './secure/roles/roles.component';
import { UserCreateComponent } from './secure/users/user-create/user-create.component';
import { UserEditComponent } from './secure/users/user-edit/user-edit.component';
import { RoleCreateComponent } from './secure/roles/role-create/role-create.component';
import { RoleEditComponent } from './secure/roles/role-edit/role-edit.component';
import { PlantsComponent } from './secure/plants/plants.component';
import { PlantEditComponent } from './secure/plants/plant-edit/plant-edit.component';
import { DictionaryComponent } from './secure/dictionary/dictionary.component';
import { CentroCostoComponent } from './secure/centro-costo/centro-costo.component';
import { FuenteContratoComponent } from './secure/fuente-contrato/fuente-contrato.component';
import { PersonalComponent } from './secure/personal/personal.component';
//import { ScannerComponent } from './secure/scanner/scanner.component';
import { CaptureComponent } from './secure/capture/capture.component';
import { CaptureResolverGuard } from './resolver/capture-resolver.guard';
import { CodigoQrComponent } from './secure/codigo-qr/codigo-qr.component';
import { BarcodeComponent } from './secure/barcode/barcode.component';


//import { Permission } from './classes/permission';


const routes: Routes = [
  {
    path: '', component: SecureComponent,
    children: [
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      {
        path: 'users',
        component: UsersComponent,
        //canActivate: [Permission],
        //data: {permissions: ['view_users', 'edit_users']}
      },
      { path: 'users/create', component: UserCreateComponent },
      { path: 'users/:id/edit', component: UserEditComponent },
      { path: 'profile', component: ProfileComponent },
      {
        path: 'roles',
        component: RolesComponent,
        //  canActivate: [Permission],
        //  data: {permissions: ['view_roles', 'edit_roles']}
      },
      { path: 'roles/create', component: RoleCreateComponent },
      { path: 'roles/:id/edit', component: RoleEditComponent },

      { path: 'plants', component: PlantsComponent },
      { path: 'plants/create', component: PlantEditComponent },
      { path: 'plants/:id/edit', component: PlantEditComponent },

      { path: 'dictionarys', component: DictionaryComponent },

      { path: 'centroCosto', component: CentroCostoComponent },
      { path: 'fuenteContrato', component: FuenteContratoComponent },
      { path: 'personal', component: PersonalComponent },
      // { path: 'scanner', component: ScannerComponent,
      //   resolve:{
      //     resolData: CaptureResolverGuard
      //   }
      // },
      {
        path: 'capture',
        component: CaptureComponent,
        resolve:{
          resolData: CaptureResolverGuard
        }
      },
      {
        path: 'qr',
        component: CodigoQrComponent,
        resolve:{
          resolData: CaptureResolverGuard
        }
      },
      {
        path: 'barcode',
        component: BarcodeComponent,
        resolve:{
          resolData: CaptureResolverGuard
        }
      },



    ]

  },
  {
    path: '', component: PublicComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      // {
      //   path: 'barcode',
      //   component: BarcodeComponent,
      //   resolve:{
      //     resolData: CaptureResolverGuard
      //   }
      // },
    ]
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
